import PrepProcessModel from "@/models/lab/PrepProcessModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class PrepProcessCollection extends LabServiceCollection {
  model() {
    return PrepProcessModel;
  }

  prepareFilter(CollectionFilter) {
    return CollectionFilter;
  }

}
